import { Box, TableCell } from "@mui/material";
import Brightness1Icon from "@mui/icons-material/Brightness1";
import Tooltip from "../../../tooltip";

export type TColor = {
  color: string;
  label: string;
};

export const ColorCel: React.FC<TColor> = ({ color, label }) => {
  return (
    <>
      <TableCell>
        <Box
          sx={{
            display: "flex",
            flexDirection: "row",
            alignItems: "center",
            justifyContent: "flex-start",
            gap: "10px",
          }}
        >
          <Tooltip
            sx={{
              margin: "5px",
            }}
            arrow
            placement="top"
            title={label}
          >
            <Brightness1Icon
              sx={{
                fill: color,
              }}
            />
          </Tooltip>
          {label}
        </Box>
      </TableCell>
    </>
  );
};
